import { jsxs as j, jsx as a } from "react/jsx-runtime";
import m from "react";
import { getThumbnailByType as h } from "../../utils/get-thumbnail-by-type.mjs";
import { twMerge as r } from "tailwind-merge";
import "../../enums/file-type-enum.mjs";
import { FileTypeEnum as u } from "@systemeio/types";
const t = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), E = m.memo(
  ({
    src: e,
    fileType: n,
    alt: x,
    className: p,
    isThumbnail: d = !1,
    width: v,
    height: i,
    title: w
  }) => {
    const [l, s] = m.useState(o.has(e)), [c, f] = m.useState(t.has(e));
    return /* @__PURE__ */ j(
      "div",
      {
        className: r("flex items-center justify-center", p),
        style: {
          width: v,
          height: i,
          minHeight: i
        },
        title: w,
        children: [
          n !== u.Video && /* @__PURE__ */ a(
            "img",
            {
              src: e,
              alt: x,
              className: r(
                "flex-2 w-full rounded-md object-cover",
                d && "h-full object-cover",
                !l && c ? "block" : "hidden"
              ),
              onLoad: () => {
                f(!0), t.add(e), o.delete(e);
              },
              onError: () => {
                s(!0), t.delete(e), o.add(e);
              }
            }
          ),
          n === u.Video && /* @__PURE__ */ a(
            "video",
            {
              src: e,
              className: r(
                "flex-2 w-full rounded-md object-cover",
                d && "h-full object-cover",
                !l && c ? "block" : "hidden"
              ),
              onLoadedData: () => {
                f(!0), t.add(e), o.delete(e);
              },
              onError: () => {
                s(!0), t.delete(e), o.add(e);
              },
              controls: !d
            }
          ),
          /* @__PURE__ */ a(
            "div",
            {
              className: r(
                "flex-2 flex items-center justify-center rounded-md",
                !d && "min-h-[300px]",
                !e || l ? "flex" : "hidden"
              ),
              children: h(n)
            }
          )
        ]
      }
    );
  }
);
E.displayName = "FilePreview";
export {
  E as FilePreview
};
